import react from 'react';
import './footer.css';

function footer(){
    return(
    <div className='footer'>
       &#169; Netflix 2021
    </div>)
}

export default footer;